import { BsStarFill, BsQuote } from "react-icons/bs";

const testimonials = [
  {
    name: "Chukwuemeka Obi",
    location: "Enugu, Nigeria",
    text: "Perfect Shelters delivered my bungalow plan within days. The design was professional, regulatory-compliant, and exceeded my expectations. I highly recommend them to anyone building in Nigeria.",
    rating: 5,
    initials: "CO",
  },
  {
    name: "Amina Bello",
    location: "Abuja, Nigeria",
    text: "I was skeptical about purchasing plans online, but the team walked me through everything via WhatsApp. The duplex design was beautifully detailed — my builder had zero issues working from it.",
    rating: 5,
    initials: "AB",
  },
  {
    name: "Seun Adeleke",
    location: "Lagos, Nigeria",
    text: "Incredible service. I requested a custom modification to a 4-bedroom bungalow plan and they handled it quickly and professionally. The pricing is very fair for the quality you get.",
    rating: 5,
    initials: "SA",
  },
];

function Testimonials() {
  return (
    <section className="bg-gray-900 py-16 md:py-24 font-Montserrat">
      <div className="max-w-6xl mx-auto px-4 md:px-10">
        {/* Header */}
        <div className="text-center mb-12">
          <p className="text-[#1877F2] uppercase tracking-[0.3em] text-xs md:text-sm font-semibold mb-3">
            Client Reviews
          </p>
          <h2 className="text-2xl md:text-4xl font-bold text-white mb-3">
            What Our Clients Say
          </h2>
          <div className="w-12 h-1 bg-gradient-to-r from-[#1877F2] to-blue-400 rounded-full mx-auto mb-4" />
          <p className="text-gray-400 text-sm md:text-base max-w-xl mx-auto">
            We've helped hundreds of Nigerians bring their home visions to life.
            Here's what some of them have to say.
          </p>
        </div>

        {/* Cards */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {testimonials.map(({ name, location, text, rating, initials }) => (
            <div
              key={name}
              className="bg-gray-800 rounded-2xl p-6 md:p-8 border border-gray-700 hover:border-[#1877F2]/40 hover:shadow-lg hover:shadow-[#1877F2]/5 transition-all duration-300 flex flex-col relative overflow-hidden"
            >
              {/* Large decorative quote */}
              <BsQuote className="absolute top-4 right-5 text-6xl text-gray-700 rotate-180" />

              {/* Stars */}
              <div className="flex gap-1 mb-4">
                {Array.from({ length: rating }).map((_, i) => (
                  <BsStarFill key={i} className="text-yellow-400 text-sm" />
                ))}
              </div>

              {/* Quote */}
              <p className="text-gray-300 text-sm leading-relaxed flex-1 mb-6 relative z-10">
                "{text}"
              </p>

              {/* Author */}
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 rounded-full bg-gradient-to-br from-[#1877F2] to-blue-400 flex items-center justify-center text-white font-bold text-sm flex-shrink-0">
                  {initials}
                </div>
                <div>
                  <p className="font-bold text-white text-sm">{name}</p>
                  <p className="text-gray-500 text-xs">{location}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Testimonials;
